/**
 * @param callback = focusAtTop() in BackToTopTrigger.tsx
 * @description The complexity is required here because Safari would often not paint the top most component after the scroll.
 * To counteract this wait until the scroll is almost complete before focusing the element, which gives Safari time to paint.
 */
export const manageFocusAtTop = (callback: () => void): void => {
  const start = performance.now();
  const timeoutMs = 500;
  const poll = (): void => {
    if (Math.abs(window.scrollY) <= 1) {
      callback();
      return;
    }

    if (performance.now() - start > timeoutMs) {
      callback();
      return;
    }

    requestAnimationFrame(poll);
  };

  requestAnimationFrame(poll);
};
